import React, { Component } from "react";
import "./codepen.css";
class Codepen extends Component {
  componentDidMount() {
    const script = document.createElement("script");
    script.src = "https://production-assets.codepen.io/assets/embed/ei.js";
    script.async = true;
    document.body.appendChild(script);
  }

  render() {
    const { hash } = this.props;
    return (
      <p
        data-height="500"
        data-theme-id="31762"
        data-slug-hash={hash}
        data-default-tab="js,result"
        data-user="Maciej001"
        data-embed-version="2"
        data-pen-title={hash}
        data-editable="true"
        className="codepen"
      />
    );
  }
}

export default Codepen;



// WEBPACK FOOTER //
// ./src/helpers/Codepen.js